import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Devices from "./pages/Devices";
import LicenseHistory from "./pages/LicenseHistory";
import Branches from "./pages/Branches";
import FloorMap from "./pages/FloorMap";
import Warehouses from "./pages/Warehouses";
import InventoryLevels from "./pages/InventoryLevels";
import StockMovements from "./pages/StockMovements";
import Suppliers from "./pages/Suppliers";
import StockReceipts from "./pages/StockReceipts";
import NewStockReceipt from "./pages/NewStockReceipt";
import StockReceiptDetail from "./pages/StockReceiptDetail";
import StockCounts from "./pages/StockCounts";
import StockCountDetail from "./pages/StockCountDetail";
import CompanyProfile from "./pages/CompanyProfile";
import Products from "./pages/Products";
import ProductFormPage from "./pages/ProductFormPage";
import Categories from "./pages/Categories";
import Tags from "./pages/Tags";
import Staff from "./pages/Staff";
import Orders from "./pages/Orders";
import OpenAccounts from "./pages/OpenAccounts";
import CashOperations from "./pages/CashOperations";
import Settlements from "./pages/Settlements";
import Eet from "./pages/Eet";
import ChangePassword from "./pages/ChangePassword";
import Users from "./pages/Users";
import OperationSettings from "./pages/OperationSettings";
import OperationPermissions from "./pages/OperationPermissions";
import OperationEet from "./pages/OperationEet";
import Reports from "./pages/Reports";
import Exports from "./pages/Exports";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import RequirePerm from "./components/RequirePerm";
import ToastHost from "./components/ToastHost";

export default function App() {
  return (
    <>
    <ToastHost />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/branches" element={<RequirePerm perm="branches"><Branches /></RequirePerm>} />
        <Route path="/branches/:branchId/floor-map" element={<RequirePerm perm="branches"><FloorMap /></RequirePerm>} />
        <Route path="/warehouses" element={<RequirePerm perm="warehouses"><Warehouses /></RequirePerm>} />
        <Route path="/inventory" element={<RequirePerm perm="stock_levels"><InventoryLevels /></RequirePerm>} />
        <Route path="/inventory/movements" element={<RequirePerm perm="stock_levels"><StockMovements /></RequirePerm>} />
        <Route path="/suppliers" element={<Suppliers />} />
        <Route path="/stock-receipts" element={<RequirePerm anyOf={["stock_receipts", "stock_transfers", "stock_corrections"]}><StockReceipts /></RequirePerm>} />
        <Route path="/stock-receipts/new" element={<RequirePerm anyOf={["stock_receipts", "stock_transfers", "stock_corrections"]}><NewStockReceipt /></RequirePerm>} />
        <Route path="/stock-receipts/:id" element={<RequirePerm anyOf={["stock_receipts", "stock_transfers", "stock_corrections"]}><StockReceiptDetail /></RequirePerm>} />
        <Route path="/stock-receipts/:id/edit" element={<RequirePerm anyOf={["stock_receipts", "stock_transfers", "stock_corrections"]}><NewStockReceipt /></RequirePerm>} />
        <Route path="/stock-counts" element={<RequirePerm perm="stock_counts_view"><StockCounts /></RequirePerm>} />
        <Route path="/stock-counts/:id" element={<RequirePerm perm="stock_counts_view"><StockCountDetail /></RequirePerm>} />
        <Route path="/catalog" element={<Navigate to="/catalog/products" replace />} />
        <Route path="/catalog/products" element={<RequirePerm perm="catalog"><Products /></RequirePerm>} />
        <Route path="/catalog/products/new" element={<RequirePerm perm="catalog" level="write"><ProductFormPage /></RequirePerm>} />
        <Route path="/catalog/products/:id/edit" element={<RequirePerm perm="catalog" level="write"><ProductFormPage /></RequirePerm>} />
        <Route path="/catalog/categories" element={<RequirePerm perm="catalog"><Categories /></RequirePerm>} />
        <Route path="/catalog/tags" element={<RequirePerm perm="catalog"><Tags /></RequirePerm>} />
        <Route path="/finance" element={<Navigate to="/finance/receipts" replace />} />
        <Route path="/finance/receipts" element={<RequirePerm perm="accounts"><Orders /></RequirePerm>} />
        <Route path="/finance/open-accounts" element={<RequirePerm perm="accounts"><OpenAccounts /></RequirePerm>} />
        <Route path="/finance/cash-operations" element={<RequirePerm perm="cash_ops"><CashOperations /></RequirePerm>} />
        <Route path="/finance/settlements" element={<RequirePerm perm="settlements"><Settlements /></RequirePerm>} />
        <Route path="/finance/eet" element={<RequirePerm perm="eet_history"><Eet /></RequirePerm>} />
        <Route path="/orders" element={<Navigate to="/finance/receipts" replace />} />
        <Route path="/orders/open-accounts" element={<Navigate to="/finance/open-accounts" replace />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/operation-settings" element={<RequirePerm roles={["owner", "manager"]}><OperationSettings /></RequirePerm>} />
        <Route path="/operation-settings/permissions" element={<RequirePerm perm="pos_permissions"><OperationPermissions /></RequirePerm>} />
        <Route path="/operation-settings/eet" element={<RequirePerm roles={["owner", "manager"]}><OperationEet /></RequirePerm>} />
        <Route path="/staff" element={<RequirePerm perm="staff"><Staff /></RequirePerm>} />
        <Route path="/devices" element={<RequirePerm perm="devices"><Devices /></RequirePerm>} />
        <Route path="/devices/license-history" element={<RequirePerm roles={["owner"]}><LicenseHistory /></RequirePerm>} />
        <Route path="/profile" element={<CompanyProfile />} />
        <Route path="/users" element={<Users />} />
        <Route path="/reports" element={<RequirePerm anyOf={["revenue_overview", "attendance"]}><Reports /></RequirePerm>} />
        <Route path="/reports/export" element={<RequirePerm perm="exports"><Exports /></RequirePerm>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}
